import { MarkerItem, Markers } from './types';

// Splits an array of strings into individual words, removing extra spaces
export function separateSetIntoWords(arr: Array<string>): Array<string> {
	const removeRepeated = new Set(arr.flatMap(item => item.split(',').map(word => word.trim())));
	return Array.from(removeRepeated);
}

// Capitalizes each word in a string
export function capitalizeWords(str: string): string {
	return str
		.split(' ')
		.map(word => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
}

// Checks if any word in the string exists in the array
export function checkIfWordsExist(str: string, arr: string[]): boolean {
	const words = str.split(',').map(word => word.trim());
	return words.some(word => arr.includes(word));
}

export const createMarker = (
	item: MarkerItem,
	markers: Markers,
	map: google.maps.Map
): google.maps.marker.AdvancedMarkerElement => {
	const lat = parseFloat(item.data.lat);
	const lng = parseFloat(item.data.lng);
	return new markers.AdvancedMarkerElement({
		map,
		gmpClickable: true,
		title: item.data.title,
		content: item.pin.getElement(),
		position: { lat, lng },
	});
};
